import { cn } from "@/lib/utils";

const STAGE_STYLE = {
  "pre-op":     { chip: "nn-chip-blue",  label: "Pre-op" },
  "intra-op":   { chip: "nn-chip-amber", label: "Intra-op" },
  "post-op":    { chip: "nn-chip-ok",    label: "Post-op" },
  "follow-up":  { chip: "nn-chip",       label: "Follow-up" },
  "archived":   { chip: "nn-chip",       label: "Archived" },
};

const COMPLEXITY_STYLE = {
  routine:      "nn-chip",
  complex:      "nn-chip-blue",
  "high-risk":  "nn-chip-warn",
};

export function StageChip({ stage, className }) {
  const s = STAGE_STYLE[stage] || STAGE_STYLE["archived"];
  return <span className={cn("nn-chip", s.chip, className)}>{s.label}</span>;
}

export function ComplexityChip({ complexity, className }) {
  const c = COMPLEXITY_STYLE[complexity] || "nn-chip";
  return (
    <span className={cn("nn-chip", c, className)}>
      {complexity === "high-risk" ? "High-risk" : complexity.charAt(0).toUpperCase() + complexity.slice(1)}
    </span>
  );
}
